<template>
    <div>
        <div class="vx-row">
            <div class="vx-col w-full">
                <vx-card title="Packages" id="resellerPackagesDiv"  class="vs-con-loading__container">

                    <vs-button color="success" icon-pack="feather" icon="icon-save" class="mb-3" @click="savePackages">Save</vs-button>

                    <div class="vx-row">
                        <div class="vx-col w-6/12">
                            <vs-table ref="packagesTable" :data="resellerPackages" class="mt-3" pagination search :maxItems="20">

                                <template slot="thead">
                                    <vs-th sort-key="package_name">Name</vs-th>
                                    <vs-th sort-key="credits">Credits</vs-th>
                                    <vs-th sort-key="days">Days</vs-th>
                                    <vs-th></vs-th>
                                </template>

                                <template slot-scope="{data}">
                                    <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                                        <vs-td :data="data[index].package_name">
                                            {{ data[index].package_name }}
                                        </vs-td>

                                        <vs-td :data="data[index].credits">
                                            {{ data[index].credits }}
                                        </vs-td>

                                        <vs-td :data="data[index].days">
                                            {{ data[index].days }}
                                        </vs-td>

                                        <vs-td>
                                            <vs-button color="danger" icon-pack="feather" icon="icon-trash-2" @click="removePackage(index)"/>
                                        </vs-td>

                                    </vs-tr>
                                </template>
                            </vs-table>
                        </div>
                        <div class="vx-col w-6/12">
                            <vs-table ref="availablePackagesTable" :data="availableResellerPackages" class="mt-3" pagination search :maxItems="20">

                                <template slot="thead">
                                    <vs-th sort-key="package_name">Name</vs-th>
                                    <vs-th sort-key="credits">Credits</vs-th>
                                    <vs-th sort-key="days">Days</vs-th>
                                    <vs-th></vs-th>
                                </template>

                                <template slot-scope="{data}">
                                    <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                                        <vs-td :data="data[index].package_name">
                                            {{ data[index].package_name }}
                                        </vs-td>

                                        <vs-td :data="data[index].credits">
                                            {{ data[index].credits }}
                                        </vs-td>

                                        <vs-td :data="data[index].days">
                                            {{ data[index].days }}
                                        </vs-td>

                                        <vs-td>
                                            <vs-button color="success" icon-pack="feather" icon="icon-plus" @click="addPackage(index)"/>
                                        </vs-td>

                                    </vs-tr>
                                </template>
                            </vs-table>
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>
<script>

    export default {
        props: {
            resellerId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {

                resellerPackages: [],
                availableResellerPackages: []

            }
        },
        methods: {
            loadPackages() {
                this.$vs.loading({
                    container: '#resellerPackagesDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const channelsPromise = this.$http.get('/api/management/v1/reseller/' + this.resellerId + '/packages')
                channelsPromise.then(function(response) {
                    thisIns.resellerPackages = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const availableChannelsPromise = this.$http.get('/api/management/v1/reseller/' + this.resellerId + '/packages/available')
                availableChannelsPromise.then(function(response) {
                    thisIns.availableResellerPackages = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                Promise.all([channelsPromise, availableChannelsPromise]).finally(function() {
                    thisIns.$vs.loading.close('#resellerPackagesDiv > .con-vs-loading')
                })
            },
            savePackages() {
                this.$vs.loading({
                    container: '#resellerPackagesDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const savePromise = this.$http.put('/api/management/v1/reseller/' + this.resellerId + '/packages', this.resellerPackages)
                savePromise.then(function() {
                    thisIns.$printSuccess('Packages saved!')
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#resellerPackagesDiv > .con-vs-loading')
                })
            },
            removePackage(index) {
                this.availableResellerPackages.push(...this.resellerPackages.splice(index, 1))
            },
            addPackage(index) {
                this.resellerPackages.push(...this.availableResellerPackages.splice(index, 1))
            }
        },
        mounted() {
            this.loadPackages()
        }
    }

</script>
